// @ts-nocheck

import OsagoPowerMultiplierForm from './OsagoPowerMultiplierForm';
import OsagoPowerMultiplierList from './OsagoPowerMultiplierList';

export default { OsagoPowerMultiplierList, OsagoPowerMultiplierForm };
